<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4" :type="'session'"></ContentLoader>
    </div>
    <div
      v-else
      class="bg-white ring-1 ring-gray-darkest min-h-full mb-2 rounded-lg duration-500 shadow-all flex flex-col w-full"
    >
      <div class="relative">
        <img
          class="rounded-lg w-full h-48 shadow-all duration-500 cursor-pointer object-cover"
          :src="baseUrlSrc(d.thumbnail_url)"
          alt="..."
        />
        <div class="flex justify-end -mt-10 mr-2">
          <span
            class="font-normal text-white rounded-lg bg-gray-dark py-1 mb-1 px-4 flex justify-center"
          >
            36:20
          </span>
        </div>
      </div>
    </div>
    <div class="ml-1">
      <div class="capitalize">
        {{ d.title }}
      </div>
      <div class="flex justify-between text-sm text-gray-light">
        ${{ d.cost }} . 300 Views
      </div>
    </div>
    <div></div>
  </section>
</template>
<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";

export default {
  components: {
    ContentLoader,
  },
  props: {
    d: {
      type: Object,
    },
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
};
</script>
